module.exports = __webpack_public_path__ + "img/wavs.43fdd6a8.gif";